

export default function UserAvatar() {
  return (
      <h1>UserAvatar</h1>
  )
}
